export default "/images/69c900de1328d9e2b207d482a51d78fb.png";